import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  data: null,
  loading: false,
  error: null
}

const expiringUserSlice = createSlice({
  name: 'expiringUser',
  initialState,
  reducers: {
    setExpiringUserData: (state, action) => {
      state.data = action.payload
    },
    setExpiringUserLoading: (state, action) => {
      state.loading = action.payload
    },
    setExpiringUserError: (state, action) => {
      state.error = action.payload
    }
  }
})

export const {setExpiringUserData, setExpiringUserLoading, setExpiringUserError} = expiringUserSlice.actions

export const selectExpiringUserData = (state) => state.expiringUser?.data ?? null
export const selectExpiringUserLoading = (state) => state.expiringUser?.loading ?? false
export const selectExpiringUserError = (state) => state.expiringUser?.error ?? null

export default expiringUserSlice.reducer
